export const SYSTEMS = {
  ze: "ecom",
  zs: "stream",
  zl: "launch",
  zi: "innovations",
  ecom: "ze",
  stream: "zs",
  launch: "zl",
  innovations: "zi",
};

export const PLATFORM_LOGO = {
  [SYSTEMS.ecom]: {
    title: "Ecom Login",
    iconUrl: "/ecomico.png",
  },
  [SYSTEMS.stream]: {
    title: "Stream Login",
    iconUrl: "/streamico.png",
  },
  [SYSTEMS.launch]: {
    title: "Launch Login",
    iconUrl: "/launchico.png",
  },
  [SYSTEMS.innovations]: {
    title: "Zeal Innovations Login",
    iconUrl: "/innoico.png",
  },
};

export const AUTH_STATUS = {
  IDLE: "idle",
  PENDING: "pending",
  DECLINED: "declined",
  APPROVED: "approved",
};

export const REGEX_PATTERN = {
  USER_PASS:
    /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*()\\-`.+,/|])[a-zA-Z0-9!@#$%^&*()\\-`.+,/|]{6,128}$/,
};
export const FORM_VALIDATION_MESSAGE = {
  USER_PASS:
    "Password includes number, letter, special characters, and 6 character minimum.",
};
